import { PaymentStatementProduct, PaymentStatementSchedule, PaymentStatementUser } from '@models/paymentStatement';
import { ProgramScheduleUser } from './program-schedule';

export enum ProgramInvoiceStatus { // ISSUED -> VIEWED -> EXPIRED -> CANCELLED
  ISSUED = 'issued', // 파트너가 수강증을 발행함
  VIEWED = 'viewed', // 고객이 수강증을 조회함
  PAID = 'paid', // 고객이 결제함
  EXPIRED = 'expired', // 고객이 결제하지 않음
  CANCELLED = 'cancelled', // 파트너가 취소함
}

export const INPUT_OPTION_LABEL: { [key: string]: string } = {
  name: '이름',
  birthYear: '출생년도',
  gender: '성별',
};

export const WEEKDAY_LABEL: { [key: string]: string } = {
  monday: '월',
  tuesday: '화',
  wednesday: '수',
  thursday: '목',
  friday: '금',
  saturday: '토',
  sunday: '일',
};

export type ProgramInvoiceDto = Omit<
  ProgramInvoice,
  '_id' | 'partnerId' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'status' | 'lastViewedAt' | 'lastSentAt'
>;

export interface ProgramInvoiceSchedule {
  type: 'day' | 'week' | 'month';
  dates?: Date[];
  weekdays?: string[];
  weeklyFrequency?: number;
  time?: { hour: number; minute: number };
}

export type ProgramInvoicePayment = WeeklyPayment | MonthlyPayment;

export interface WeeklyPayment {
  type: 'weekly';
  amount: number;
  paymentDayOfWeek: number;
}

export interface MonthlyPayment {
  type: 'monthly';
  amount: number;
  paymentDayOfMonth: number;
}

export interface ProgramInvoice {
  _id: string;
  type?: string;
  title?: string;
  amount?: number;
  repeat?: boolean;
  repeatDayOfWeek?: string;
  repeatDayOfMonth?: string;
  totalSessionCount?: number;
  groupDiscountTarget?: number;
  invoiceSchedule?: ProgramInvoiceSchedule;
  participants?: { name: string; birthYear: string; gender: string }[];
  requestParticipantsInfo?: {
    enable?: boolean;
    inputOptions?: string[]; // name, birthYear, gender
  };
  seller?: PaymentStatementUser;
  product?: PaymentStatementProduct;
  representative?: ProgramScheduleUser;
  schedules?: PaymentStatementSchedule[];
  memo?: string;
  status?: string;
  validUntil?: Date;
  lastViewedAt?: Date;
  lastSentAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
  duration?: {
    hour: number;
    minute: number;
    duration: number;
  };
}

export interface PublishedUser {
  id: string;
  name: string;
  phone: string;
}

export interface ProgramInvoiceTemplate {
  _id: string;
  partnerId: string;
  templateName?: string;
  invoiceData?: Partial<ProgramInvoice>;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export type ProgramInvoiceTemplateDto = Omit<
  ProgramInvoiceTemplate,
  '_id' | 'partnerId' | 'createdAt' | 'updatedAt' | 'deletedAt'
>;

export interface ProgramInvoiceEditData
  extends Omit<
    ProgramInvoice,
    '_id' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'status' | 'lastViewedAt' | 'lastSentAt'
  > {
  duration?: { hour: number; minute: number; duration: number };
}

export type CreateProgramInvoiceDto = ProgramInvoiceEditData;
export type UpdateProgramInvoiceDto = Partial<ProgramInvoiceEditData>;
